<template>
  <v-container>
    <!-- <div v-if="alerta">
        <alert-empty></alert-empty>
      </div> -->
    <v-layout>
      <v-flex>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">Traspaso CA-CO</v-toolbar-title>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <grid-traspaso
          :key="traspasoGrid"
          :contratoId="contratoId"
        ></grid-traspaso>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";
import GridTraspaso from "./GridTraspaso.vue";
// import AlertEmpty from "@/views/ui/AlertEmpty.vue";
// import {misMixins} from "@/mixins/myMixing.js";
import axios from "axios";

export default {
  name: "visita-sub-tab",

  components: {
    GridTraspaso,
    // AlertEmpty,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
  },
  data() {
    return {
      contratoId: "",
      traspasoGrid: 0,
    };
  },

  computed: {},

  created() {
    this.contratoId = this.$store.getters.contratoStored;
  },
  methods: {},
};
</script>
